/* eslint-disable react/no-unescaped-entities */
import React from "react";
import { Col, Row } from "reactstrap";
import { Faq } from "src/components/General/Faq";

export const CommunityFaq: React.FunctionComponent = () => {
  return (
    <div className="mt-2">
      <Row>
        <Col>Profiles</Col>
      </Row>
      <Faq
        items={[
          {
            title: "How do I enter my website link?",
            content: (
              <div>
                When dealing with web addresses, we need to identify the protocol ie http/https. Go to your website and
                copy the web address right out of the URL bar and paste the link directly into the website category in
                the profile builder.
              </div>
            ),
          },
          {
            title: "How do I upload my photo?",
            content: (
              <div>
                Photos uploaded to Psychedelic Support should be good high resolution shots of minimum dimensions 800px
                (w) by 800px (h). If you have some headshots from a professional photographer, they'll do great unless
                they've been reduced in size for another web application! If you're having trouble with uploading your
                images, please email a copy of the image to{" "}
                <a href="mailto:info@psychedelic.support">info@psychedelic.support</a> and we will size it for you!
              </div>
            ),
          },
        ]}
      />
    </div>
  );
};
